<template>
  <div id="news">
    <headerbom :hdtitle="'新闻列表'"></headerbom>
    <div class="banner">
      <img src="../img/news1.png" alt="">
    </div>
    <div class="news_btn">
      <span :class="{active: activeIndex == 0}" @click="topage(0)">企业动态</span>
      <span :class="{active: activeIndex == 1}" @click="topage(1)">行业动态</span>
    </div>
    <ul class="list">
      <li v-for="(ele,index) in list" :key="index" :class="{no_margin: index % 2 == 0}" @click="opennews(ele.jumpLink)">
        <div class="img">
          <img :src="ele.imgUrl" alt="">
        </div>
        <h1>{{ele.title}}</h1>
        <p>{{ele.newsContent}}</p>
        <span>{{ele.editTime.substring(0,10)}}</span>
      </li>
    </ul>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      activeIndex: 0,
      list1: [],
      list2: [],
      list: [],
    };
  },
  computed: {},
  components: {},
  created() { },
  destroyed() { },
  mounted() {
    this.GetNewsInfoList()
  },
  methods: {
    topage(num) {
      if (num == 0) {
        this.activeIndex = 0;
        this.ismore = false;
        this.list = JSON.parse(JSON.stringify(this.list1));
      } else {
        this.activeIndex = 1;
        this.ismore = false;
        this.list = JSON.parse(JSON.stringify(this.list2));
      }
    },
    opennews(alink) {
      window.open(alink);
    },
    /**获取列表 */
    GetNewsInfoList() {
      let url = "https://api.asa.adjz.com/api/Tool/GetNewsInfoList";
      this.$https.get(url).then((res) => {
        if (this.$route.query.type == 'enterprise') {
          res.data.map(ele => {
            if (ele.tagsName.indexOf('企业动态') != -1) {
              this.list1.push(ele)
            }
          })
        } else {
          res.data.map(ele => {
            if (ele.tagsName.indexOf('企业动态') == -1) {
              this.list2.push(ele)
            }
          })
        }
        if (this.$route.query.type == "enterprise") {
          this.activeIndex = 0;
          this.list = JSON.parse(JSON.stringify(this.list1));
        } else {
          this.activeIndex = 1;
          this.list = JSON.parse(JSON.stringify(this.list2));
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#news {
  box-sizing: border-box;
  padding-top: 1rem;
  .banner {
    img {
      width: 100%;
      height: auto;
    }
  }
  .news_btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 1rem 0 0.5rem;
    span {
      display: block;
      width: 1.7rem;
      height: 0.6rem;
      border: 0.25rem;
      text-align: center;
      border-radius: 0.3rem;
      line-height: 0.58rem;
      font-size: 0.28rem;
      background: #f6f6f6;
      color: #333;
      margin: 0 0.15rem;
      border: 0.01rem solid #dcdfe6;
      &.active {
        background: #108ee9;
        color: #fff;
        border: 0.01rem solid #108ee9;
      }
    }
  }
  .list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.22rem;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.6rem;
    li {
      width: 47%;
      margin-left: 6%;
      margin-bottom: 0.48rem;
      box-sizing: border-box;
      padding: 0.32rem 0.24rem;
      box-shadow: 0 0 0.12rem 0.02rem rgba(145, 186, 245, 0.3);
      border-radius: 0.12rem;
      &.no_margin {
        margin-left: 0;
      }
      img {
        width: 100%;
        height: auto;
        border-radius: 0.1rem;
        margin-bottom: 0.2rem;
      }
      h1 {
        font-size: 0.18rem;
        color: #333;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        line-height: 0.26rem;
        letter-spacing: 0.01rem;
      }
      p {
        font-size: 0.14rem;
        color: #666;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin-top: 0.1rem;
        line-height: 0.3rem;
      }
      span {
        font-size: 0.14rem;
        color: #666;
        margin-top: 0.1rem;
        display: block;
      }
    }
  }
}
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/page/news/index.vue